import './TimeDisplay.css';
type Props = {
    time: number;
    start?: boolean
};

export function TimeDisplay({ time, start }: Props) {
    const formatTime = (time: number) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60).toString().padStart(2, '0');
        return `${minutes}:${seconds}`;
    };

    return (
    <span className='timeDisplayContainer'>
        <span className={start ? 'timeDisplay start' : 'timeDisplay'}>{formatTime(time)}</span>
    </span>);
}
